<template>
  <div class="notificaciones">
    <transition name="slide-fade">
      <h1 class="mb-0" v-if="showTitle">{{msg}}</h1>
    </transition>
    <el-alert class="mt-3" :title="desc" type="info" :closable="false"></el-alert>
    <div class="filtro mt-3">
      <div class="row">
        <div class="col-md-4">
          <legend class="col-form-legend pt-0">Roles o usuarios</legend>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="roles"
              v-model="tipo"
              class="custom-control-input"
              value="roles"
            >
            <label class="custom-control-label" for="roles">Roles</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="usuarios"
              v-model="tipo"
              class="custom-control-input"
              value="usuarios"
            >
            <label class="custom-control-label" for="usuarios">Usuarios</label>
          </div>
        </div>
        <div class="col-md-8" v-if="tipo === 'roles'">
          <h3 class>Roles</h3>
          <div class="w-100">
            <template>
              <el-select
                v-model="rolesSelect"
                multiple
                filterable
                reserve-keyword
                placeholder="Introduzca un rol"
                v-loading="loadingRoles"
              >
                <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </div>
        </div>
        <div class="col-md-8" v-else>
          <h3 class>Usuarios</h3>
          <div class="w-100">
            <template>
              <el-select
                v-model="usersSelect"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Introduzca un teléfono"
                :remote-method="remoteMethod"
              >
                <div class="options-wrapp" v-loading="loadingUsers">
                  <el-option
                    v-for="item in usersOptions"
                    :key="item.id"
                    :label="item.phone"
                    :value="item.id"
                  ></el-option>
                </div>
              </el-select>
            </template>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4">
          <div class>
            <avatar-cropper
              ref="cropperAvatar"
              :upload-handler="cropperAvatarHandler"
              trigger="#cropper-avatar"
              :mimes="cropperAllowedInputMimes"
              :output-mime="cropperOutputMime"
              :output-quality="0.9"
              :cropper-options="cropperAvatarOptions"
              :output-options="cropperAvatarOutputOptions"
              :labels="cropperLabels"
              @changed="cropperAvatarChanged"
            />
            <img :src="imgDataUrl" class="card-img-top img-fluid">
            <div class="mt-3 d-flex justify-content-between">
              <button
                class="btn"
                :class="{'btn-light': submitDisabled, 'btn-success': !submitDisabled}"
                @click="sendNotification"
                :disabled="submitDisabled"
              >
                <i class="fa fa-paper-plane" aria-hidden="true"></i> Enviar
              </button>
              <button id="cropper-avatar" class="btn btn-primary text-white" @click="toggleShow">
                <i class="fa fa-camera" aria-hidden="true"></i> Imagen
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <b-form-group label="Título*" class="titulo">
            <b-form-input
              require
              v-model="titulo"
              placeholder="Título del detalle la notificación"
              :class="{ 'is-invalid': attemptSubmit && missingNotificationTitle }"
            ></b-form-input>
            <div class="invalid-feedback">Campo obligatorio</div>
          </b-form-group>
          <b-form-group label="Mensaje*" class="mensaje mb-0">
            <b-form-textarea
              rows="7"
              require
              maxlength="2000"
              v-model="mensajeHTML"
              placeholder="Estimados usuarios, lorem ipsum dolor sit amet.."
              :class="{ 'is-invalid': attemptSubmit && missingNotificationBody }"
            ></b-form-textarea>
            <div class="invalid-feedback">Campo obligatorio</div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Título del detalle*" class="titulo">
            <b-form-input
              require
              v-model="detailTitle"
              placeholder="Título de la notificación"
              :class="{ 'is-invalid': attemptSubmit && missingDetailTitle }"
            ></b-form-input>
            <div class="invalid-feedback">Campo obligatorio</div>
          </b-form-group>
          <b-form-group label="Mensaje del detalle*" class="mensaje mb-0">
            <b-form-textarea
              rows="7"
              maxlength="2000"
              require
              v-model="detailBody"
              placeholder="Estimados usuarios, lorem ipsum dolor sit amet.."
              :class="{ 'is-invalid': attemptSubmit && missingDetailBody }"
            ></b-form-textarea>
            <div class="invalid-feedback">Campo obligatorio</div>
          </b-form-group>
        </div>
      </div>
    </div>
    <b-modal ref="modalSuccess" ok-only="true" ok-title="CERRAR">
      <h3>Notificación enviada con éxito</h3>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import AvatarCropper from "vue-avatar-cropper";

import axios from "axios";
import { APIENDPOINT } from "@/backend";

export default {
  name: "Notifications",
  components: {
    AvatarCropper
  },

  computed: {
    missingNotificationTitle() {
      return this.titulo === "";
    },

    missingNotificationBody() {
      return this.mensajeHTML === "";
    },

    missingDetailTitle() {
      return this.detailTitle === "";
    },

    missingDetailBody() {
      return this.detailBody === "";
    },

    missingImg() {
      return this.imgDataUrl === "https://via.placeholder.com/640x360";
    },

    submitDisabled() {
      return (
        this.missingNotificationTitle ||
        this.missingNotificationBody ||
        this.missingDetailTitle ||
        this.missingDetailBody
      );
    }
  },

  data() {
    return {
      showTitle: false,
      msg: "Notificaciones",
      desc: "Vamos a mandar notas",
      show: false,
      imgDataUrl: "https://via.placeholder.com/640x360",
      imgDataChanged: false,
      tipo: "roles",
      roles: [],
      rolesSelect: [],
      usuario: "",
      usuarios: [],
      titulo: "",
      detailBody: "",
      detailTitle: "",
      mensajeHTML: "",
      attemptSubmit: false,
      remoteUsers: [],
      usersSelect: [],
      list: [],
      loadingUsers: false,
      loadingRoles: false,
      usersOptions: [],
      cropperAllowedInputMimes: "image/png, image/jpeg, image/webp",
      cropperOutputMime: "image/webp",
      cropperLabels: {
        cancel: "Cancelar",
        submit: "Enviar"
      },
      cropperAvatarOptions: {
        aspectRatio: 1.777777, // para 16x9
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      },
      cropperAvatarOutputOptions: {
        width: 640,
        height: 360,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "low"
      }
    };
  },
  mounted() {
    this.showTitle = true;
    this.list = this.usersOptions.map(item => ({
      value: item,
      label: item
    }));
  },
  created: function() {
    console.clear();
    this.getRoles();
  },
  methods: {
    getRoles() {
      this.loadingRoles = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/roles"
      })
        .then(response => {
          this.loadingRoles = false;
          this.roles = response.data.data.rolesList;
        })
        .catch(e => {
          // this.errors.push(e)
        });
    },

    sendNotification() {
      this.attemptSubmit = true;

      // enviar notificacion
      let axiosData = {
        usersList: this.usersSelect,
        rolesList: this.rolesSelect,
        notificationTitle: this.titulo,
        notificationBody: this.mensajeHTML,
        detailTitle: this.detailTitle,
        detailBody: this.detailBody,
        priority: "high"
      };

      if (this.imgDataChanged) {
        axiosData.detailImg = this.imgDataUrl;
      }

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "post",
        url: "/api/v1/msg",
        data: axiosData
      })
        .then(response => {
          // console.log(response);
          if (response.data.code !== 0) {
            this.$alert("Error en el sistema", "Info", {
              confirmButtonText: "Cerrar"
            });
          } else {
            this.$alert("Notificación enviada con éxito", "Info", {
              confirmButtonText: "Cerrar",
              callback: action => {
                // this.limpiarCampos()
                this.attemptSubmit = false;
                this.usuarios = [];
                this.usersSelect = [];
                this.rolesSelect = [];
                this.imgDataUrl = "https://via.placeholder.com/640x360";
                this.imgDataChanged = false
                this.titulo = "";
                this.detailBody = "";
                this.detailTitle = "";
                this.mensajeHTML = "";
              }
            });
          }
        })
        .catch(e => {
          // this.errors.push(e)
        });
    },

    getUsers(phone) {
      // traer usuarios
      this.loadingUsers = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/users",
        params: {
          phone: phone,
          sort: this.currentField,
          sortDir: this.sortDir
        }
      })
        .then(response => {
          this.loadingUsers = false;
          if (response.data.code !== 0) {
            console.log(response.data.description);
            this.$alert("Error en el sistema", "Info", {
              confirmButtonText: "Cerrar"
            });
          } else {
            this.usersOptions = response.data.data.userList;
          }
        })
        .catch(e => {
          // this.errors.push(e)
        });
    },

    remoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          this.getUsers(query);
          this.remoteUsers = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.remoteUsers = [];
      }
    },

    toggleShow() {
      this.show = !this.show;
    },

    cropperAvatarChanged(file, reader) {
      let that = this;
      reader.addEventListener("load", function() {
        let image = new Image();
        image.src = reader.result;
        image.onload = function() {
          if (
            image.width < that.cropperAvatarOutputOptions.width ||
            image.height < that.cropperAvatarOutputOptions.height
          ) {
            that.$refs.cropperAvatar.destroy();
            that.$message({
              showClose: false,
              message:
                "Se espera un ancho y alto mínimo de " +
                that.cropperAvatarOutputOptions.width +
                "x" +
                that.cropperAvatarOutputOptions.height +
                "px.",
              type: "warning",
              duration: 4500
            });
            // console.log(reader)
          }
        };
      });
    },

    cropperAvatarHandler(cropper) {
      // console.group('cropperHandler')
      // console.log(cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime))
      // console.groupEnd()
      this.imgDataUrl = cropper
        .getCroppedCanvas(this.cropperAvatarOutputOptions)
        .toDataURL(this.cropperOutputMime);
      this.imgDataChanged = true;
    },

    waitInputUser: _.debounce(function() {
      this.usersFilter();
    }, 500)
  }
};
</script>

<style lang="scss">
legend.col-form-legend {
  font-size: 1.5em;
  font-weight: 300;
}

.w-100 .el-select {
  display: block;
}

textarea {
  height: 147px;
}
</style>
